"use strict";
/**
 * @fileoverview API request body interface for updating an existing customer
 * Uses the centralized API models with appropriate modifications for update operations
 */
Object.defineProperty(exports, "__esModule", { value: true });
